import { ReactElement } from 'react';
import { HostRunStatusCount } from '@goto/remote-execution';
import UpdateJobProgress from '../../../windows-updates/components/update-job-progress/UpdateJobProgress';

function JobProgressCellRenderer(statusCounts: HostRunStatusCount[]): ReactElement {
  return <UpdateJobProgress deviceJobStatusCounts={statusCounts} />;
}

export default JobProgressCellRenderer;
